import React from 'react';
import classNames from 'classnames';
import { RegionReportNoteButton } from '../RegionReportNoteButton/RegionReportNoteButton';
import FieldThumbnail from '../../../FieldThumbnail/FieldThumbnail';
import styles from '../RegionReport.css';
import { toDateString } from '../../../../utils/date';
import { Activity, GeoJson } from '../../../../types';

export type ThumbnailActivity = Pick<Activity, 'title' | 'color' | 'scoutedAt'>;

export type RegionThumbnailNoteBoxProps = {
  activity: ThumbnailActivity;
  geoJson: GeoJson;
  locale: string;
  fieldName: string;
  onRegionButtonClick: () => void;
  isClickable?: boolean;
  displayNoteButton?: boolean;
};

export const RegionThumbnailNoteBox = ({
  onRegionButtonClick,
  activity,
  geoJson,
  locale,
  fieldName,
  isClickable = true,
  displayNoteButton = true,
}: RegionThumbnailNoteBoxProps) => (
  <div
    className={classNames(styles.thumbnailNoteBoxRow, {
      [styles.thumbnailNoteBoxNotClickable]: !isClickable,
    })}
    data-test-id="region-note-thumbnail-region-button"
    onClick={onRegionButtonClick}
    role="button"
    tabIndex={0}
  >
    <div className={styles.fieldInfo}>
      <div className={styles.thumbnailWrapper} data-test-id="region-note-box-field-thumbnail">
        <FieldThumbnail
          fillColor="#FFF"
          geoJson={geoJson}
          regionColor={activity.color}
          regionFillOpacity={0.2}
        />
      </div>
      <div className={styles.thumbnailContent}>
        <h3 className={styles.thumbnailTitle} data-test-id="region-note-box-field-thumbnail-field-name">{fieldName}</h3>
        {activity?.title &&
          <time className={styles.thumbnailScoutedAt} data-test-id="region-note-box-region-scoutedAt">
            {toDateString(activity.scoutedAt, locale)}
          </time>
        }
      </div>
    </div>
    {displayNoteButton && (<RegionReportNoteButton
      title={activity?.title}
    />)}

  </div>
);
